export const getStripePublishableKey = () => {
  const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  return typeof key === "string" && key.trim() ? key.trim() : null;
};
